import React from 'react';
import { getWeatherDescription, getWeatherIcon } from '../utils/weatherUtils';

const DisplayWeather = (props) => {
    const isDay = props.isDay !== undefined ? props.isDay : true;
    const iconCode = getWeatherIcon(props.code, isDay);
    const iconUrl = `https://openweathermap.org/img/wn/${iconCode}@2x.png`;

    return (
        <div className="weather-box">
            <img
                src={iconUrl}
                alt={getWeatherDescription(props.code)}
                style={{ width: '100px', height: '100px' }}
            />
            <h1>{props.temp}°F</h1>
            <h1>{props.rainChance}% chance of rain</h1>
            <h1>conditions: {getWeatherDescription(props.code)}</h1>
        </div>
    );
};

export default DisplayWeather;